import { REGION } from '@sellpy/commons/lib/marketplace'
import Parse from 'parse'

export const AB_TESTS = {
  oneStepCheckout: 'oneStepCheckout',
  expressAssortment: 'expressAssortment',
  salesToSaleShareButton: 'salesToSaleShareButton',
  saleToSaleShareButton: 'saleToSaleShareButton',
  similarItemsToFavoritesInPLP: 'similarItemsToFavoritesInPLP',
  perceivedSize: 'perceivedSize',
  localPersonalisationValues: 'localPersonalisationValues',
  businessSellerSliderToCheckout: 'businessSellerSliderToCheckout',
  fastHandling: 'fastHandling',
  similarStylesFinderTwin: 'similarStylesFinderTwin',
  newContainerOrderForm: 'newContainerOrderForm',
  hideFreightPriceIfMultiple: 'hideFreightPriceIfMultiple'
}

const ALL_REGIONS = Object.values(REGION)

const abTests = {
  [AB_TESTS.oneStepCheckout]: {
    min: 0.61,
    max: 0.8,
    regions: ALL_REGIONS,
    fractions: ['user']
  },
  [AB_TESTS.expressAssortment]: {
    min: 0.5,
    max: 1,
    regions: ['SE'],
    fractions: ['user']
  },
  [AB_TESTS.salesToSaleShareButton]: {
    min: 0,
    max: 0.5,
    regions: ALL_REGIONS,
    fractions: ['user']
  },
  [AB_TESTS.saleToSaleShareButton]: {
    min: 0.5,
    max: 1,
    regions: ALL_REGIONS,
    fractions: ['user']
  },
  [AB_TESTS.similarItemsToFavoritesInPLP]: {
    min: 0,
    max: 0.5,
    regions: ALL_REGIONS,
    fractions: ['user']
  },
  [AB_TESTS.perceivedSize]: {
    min: 0.5,
    max: 1,
    regions: ALL_REGIONS,
    fractions: ['user']
  },
  [AB_TESTS.localPersonalisationValues]: {
    min: 0.0,
    max: 0.5,
    regions: ALL_REGIONS,
    fractions: ['client']
  },
  [AB_TESTS.businessSellerSliderToCheckout]: {
    min: 0.0,
    max: 0.2,
    regions: ['SE'],
    fractions: ['client']
  },
  [AB_TESTS.fastHandling]: {
    min: 0.5,
    max: 0.6,
    regions: ['SE', 'DE'],
    fractions: ['user']
  },
  [AB_TESTS.similarStylesFinderTwin]: {
    min: 0,
    max: 0.5,
    regions: ALL_REGIONS,
    fractions: ['user']
  },
  [AB_TESTS.newContainerOrderForm]: {
    min: 0.5,
    max: 1.0,
    regions: ALL_REGIONS,
    fractions: ['client']
  },
  [AB_TESTS.hideFreightPriceIfMultiple]: {
    min: 0.2,
    max: 0.45,
    regions: ALL_REGIONS,
    fractions: ['user']
  }
}

export const setAppPaymentsAbTestFraction = (fraction) => {
  window.localStorage.setItem('sellpyAbTest', fraction)
}

export const setAbTestFraction = () => {
  getABTestFraction()
  getSanityAbTestFraction()
}

export const getABTestFraction = () => {
  if (!window.localStorage.getItem('sellpyAbTest')) {
    window.localStorage.setItem('sellpyAbTest', Math.random())
  }
  return window.localStorage.getItem('sellpyAbTest')
}

export const getSanityAbTestFraction = () => {
  if (!window.localStorage.getItem('sellpySanityAbTest')) {
    window.localStorage.setItem('sellpySanityAbTest', Math.random())
  }
  return window.localStorage.getItem('sellpySanityAbTest')
}

/**
 * @deprecated Use `inNormalizedAbTestTestGroupCached` or `useSuspenseInNormalizedAbTestTestGroup`
 * depending on if we can rely on the initialization being completed or not.
 */
export const inAbTestTestGroup = (testName) => _inTestGroup(testName)

export const activeAbTests = () => Object.keys(abTests).filter(_inTestGroup)

const _inTestGroup = (testName) => {
  const abTest = abTests[testName]
  if (!abTest) return false
  // Use Parse.User.current() instead of getCurrentParseUser() to avoid circular dependency
  // eslint-disable-next-line no-restricted-syntax
  const parseUser = Parse.User.current()
  const fractions = {
    user: parseUser?.get('userAbTestFraction'),
    client: getABTestFraction()
  }
  const fraction = abTest.fractions
    .map((fractionId) => fractions[fractionId])
    .filter((fraction) => fraction != null)[0]
  return (
    abTest.min <= fraction &&
    abTest.max > fraction &&
    (abTest.regions || []).includes(process.env.REGION)
  )
}

export const ITEM_AB_TESTS = {
  skipExtraCarouselImages: 'skipExtraCarouselImages',
  showNotTestedForUntestedIOs: 'showNotTestedForUntestedIOs'
}

const itemAbTests = {
  [ITEM_AB_TESTS.skipExtraCarouselImages]: {
    min: 0,
    max: 0.5,
    regions: ALL_REGIONS
  },
  [ITEM_AB_TESTS.showNotTestedForUntestedIOs]: {
    min: 0,
    max: 0.5,
    regions: ALL_REGIONS
  }
}

/**
 * @param {String} testName
 * @param {Number} itemAbTestFraction
 */
export const itemInAbTestGroup = (testName, itemAbTestFraction) => {
  const abTest = itemAbTests[testName]
  if (!abTest) return false

  return (
    abTest.min <= itemAbTestFraction &&
    abTest.max > itemAbTestFraction &&
    (abTest.regions || []).includes(process.env.REGION)
  )
}
